import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Space, Table } from 'antd';
import { Link } from 'react-router-dom';
import { NetworkResult } from '../../../common/CommonResult';
import { useCallback, useEffect, useState } from 'react';
import { API } from '../../../api';
import { ShipmentStatusAddEdit } from './ShipmentStatusAddEdit';

export const ShipmentStatusList = () => {
  const [state, setState] = useState<NetworkResult<any[]>>({
    loading: true,
    result: [],
  });
  const [edit, changeEdit] = useState<any>({ open: false, edit: null });
  const columns = [
    {
      title: 'Код',
      dataIndex: 'cd',
      key: 'cd',
    },
    {
      title: 'Нэр',
      key: 'name',
      render: (record: any) => {
        return <span>{record.name}</span>;
      },
    },
    {
      title: 'Скан нэр',
      key: 'scanName',
      dataIndex: 'scanName',
    },
    {
      title: 'Меню',
      key: 'menu',
      render: (record: any) => (record.menu ? 'Тийм' : 'Үгүй'),
    },
    {
      title: 'Меню эрэмбэ',
      key: 'orders',
      dataIndex: 'orders',
    },
    {
      title: 'Засах',
      key: 'name',
      render: (record: any) => {
        return (
          <Button size="small" onClick={() => changeEdit({ open: true, edit: record })}>
            Засах
          </Button>
        );
      },
    },
  ];
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = useCallback(async () => {
    setState({ ...state, loading: true });
    try {
      const response = await API.get({ apiVersion: 'api' })(`/settings/shipment_status/list`);
      setState({
        loading: false,
        result: response.result,
      });
    } catch (error: any) {
      setState({ ...state, loading: true, errors: true });
    }
  }, []);
  return (
    <Card
      title={`Хүргэлтүүдийн төлөв `}
      extra={
        <Button
          type="primary"
          onClick={() => changeEdit({ open: true, edit: null })}
          icon={<PlusOutlined />}
        >
          Төлөв нэмэх
        </Button>
      }
    >
      <Space style={{ marginBottom: 16 }}></Space>
      <Table
        pagination={false}
        size="small"
        bordered
        loading={state.loading}
        dataSource={state.result || []}
        rowKey={'id'}
        columns={columns}
      />
      <ShipmentStatusAddEdit
        open={edit.open}
        onClose={() => {
          changeEdit({ open: false });
        }}
        onSuccess={() => {
          changeEdit({ open: false });
          fetchData();
        }}
        edit={edit.edit}
        statusList={state.result}
      />
    </Card>
  );
};
